module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ro-nav-item-toggle",
    on: {
      "click": _vm.openSubNav
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-d741ae30"}!/Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ro-nav/RoNavItemToggle.vue
// module id = 387
// module chunks = 1